const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

async function apiRequest(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const controller = new AbortController();
    const signal = controller.signal;

    const headers = {
        'Content-Type': 'application/json',
        ...options.headers,
    };

    if (options.token) {
        headers['Authorization'] = `Bearer ${options.token}`;
    }

    const config = {
        method: options.method || 'GET',
        headers,
        body: options.body ? JSON.stringify(options.body) : undefined,
        signal,
    };
    console.log(`
=================== HTTP Request ===================
Method   : ${config.method.toUpperCase()}
URL      : ${url}

Headers  :
${JSON.stringify(config.headers, null, 2)}

Body     :
${JSON.stringify(config.body, null, 2)}
====================================================
`);


    try {
        const response = await fetch(url, config);
        let responseData;
        try {
            responseData = await response.json();
            console.log(`
=================== HTTP Response ===================
Status   : ${response.status} ${response.statusText}
URL      : ${url}

Body     :
${JSON.stringify(responseData, null, 2)}
====================================================
`);
        } catch (parseError) {
            console.error('Failed to parse response as JSON:', parseError);
            throw new Error(`Failed to parse response as JSON: ${parseError.message}`);
        }

        return {
            ...responseData,
            ok: response.ok,
            status: response.status,
            statusText: response.statusText
        };
    } catch (error) {
        if (error.name === 'AbortError') {
            console.warn('Request aborted:', url);
        } else {
            console.error('API request failed:', error.message);
        }
        throw error;
    }
}

export {apiRequest};